import React from "react";
import { icon, label, number } from "../../../../config";
import { RECIPIENT_TYPES } from "./emailFlowConfig.constants";
import { getInitials, getRecipientChipClass, getSystemRecipientOptionInitials } from "./emailFlowConfig.utils";

/**
 * CC recipients field: chip input + dropdown (same behavior as TO).
 * State and API search live in the parent; this component is presentation only.
 */
const EmailFlowCcRecipientsField = ({
  recipients,
  inputValue,
  inputRef,
  containerRef,
  dropdownRef,
  dropdownOpen,
  hasDropdownOptions,
  filteredPredefinedOptions,
  filteredApiSuggestions,
  selectedIndex,
  onInputChange,
  onKeyDown,
  onBlur,
  onFocus,
  onRemoveRecipient,
  onSelectPredefined,
  onSelectApi,
  onOptionMouseEnter,
}) => {
  return (
    <div className='email-flow-cc-section-inner'>
      <label className='email-flow-label'>{label.CC}</label>
      <div className='email-flow-to-container' ref={containerRef}>
        <div className='email-flow-to-input-wrapper' onClick={() => inputRef.current?.focus()}>
          {recipients?.map((recipient) => {
            let displayName = recipient.Name || recipient.Email;
            if (recipient?.Type === RECIPIENT_TYPES.SYSTEM && displayName?.startsWith("@")) {
              displayName = displayName.substring(number.ONE);
            }
            return (
              <div key={recipient?.Id} className={getRecipientChipClass(recipient?.Type)}>
                <span className='email-flow-chip-text'>{displayName}</span>
                <span
                  className='email-flow-chip-remove'
                  onClick={(e) => {
                    e.stopPropagation();
                    onRemoveRecipient(recipient?.Id);
                  }}
                  title='Remove'>
                  {icon.CLOSE}
                </span>
              </div>
            );
          })}
          <input
          autoComplete="off"
            ref={inputRef}
            type='text'
            className='email-flow-to-input'
            value={inputValue}
            onChange={onInputChange}
            onKeyDown={onKeyDown}
            onBlur={onBlur}
            onFocus={onFocus}
            placeholder={recipients.length === number.ZERO ? label.ADD_CC : ""}
          />
        </div>
        {dropdownOpen && hasDropdownOptions && (
          <div className='email-flow-to-dropdown' ref={dropdownRef}>
            {filteredPredefinedOptions?.length > number.ZERO && (  
              <>
                <div className='email-flow-dropdown-section-label'>{label.SYSTEM_RECIPIENTS}</div>
                {filteredPredefinedOptions?.map((option, index) => (
                  <div
                    key={option?.id}
                    className={`email-flow-to-option ${selectedIndex === index ? "selected" : ""}`}
                    onMouseDown={(e) => e.preventDefault()}
                    onClick={(e) => {
                      e.stopPropagation();
                      onSelectPredefined(option);
                    }}
                    onMouseEnter={() => onOptionMouseEnter(index)}>
                    <div className='email-flow-to-option-avatar'>{getSystemRecipientOptionInitials(option)}</div>
                    <div className='email-flow-to-option-label'>{option?.label}</div>  
                  </div>
                ))}
              </>
            )}
            {filteredApiSuggestions?.length > number.ZERO && (
              <>
                <div className='email-flow-dropdown-section-label'>{label.CONTACTS}</div>
                {filteredApiSuggestions?.map((contact, index) => {
                  const adjustedIndex = filteredPredefinedOptions?.length + index;
                  return (
                    <div
                      key={contact?.Id || contact?.Email}
                      className={`email-flow-to-option ${selectedIndex === adjustedIndex ? "selected" : ""}`}
                      onMouseDown={(e) => e.preventDefault()}
                      onClick={(e) => {
                        e.stopPropagation();
                        onSelectApi(contact);
                      }}
                      onMouseEnter={() => onOptionMouseEnter(adjustedIndex)}>
                      {contact?.PhotoLinks?.small ? (  
                        <img src={contact.PhotoLinks.small} alt={contact.Name} className='email-flow-to-option-photo' />
                      ) : (
                        <div className='email-flow-to-option-avatar'>{getInitials(contact.Name || contact.Email)}</div>
                      )}
                      <div className='email-flow-to-option-details'>
                        <div className='email-flow-to-option-name'>{contact.Name || contact.Email}</div>
                        {contact?.Name && contact?.Email && <div className='email-flow-to-option-email'>{contact?.Email}</div>}
                      </div>
                    </div>
                  );
                })}
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default EmailFlowCcRecipientsField;
